<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
  import CurrencyInput from './CurrencyInput.vue'
  import ModalHelp from './ModalHelp.vue'
  import SinNumber from './SinNumber.vue'
  import PhoneNumber from './PhoneNumber.vue'
  import VariableCountFormSection from './VariableCountFormSection.vue'
  import RegistrationAccount from "./RegistrationAccount"
  import RegistrationStatus from "./RegistrationStatus"
  import DateInput from "./DateInput";
  import DistributionForm from "./DistributionForm";

  export default {
    components: {
      CurrencyInput,
      VariableCountFormSection,
      ModalHelp,
      SinNumber,
      PhoneNumber,
      RegistrationAccount,
      RegistrationStatus,
      DateInput,
      DistributionForm,
    },

    props: {
      initialTrigger: {default: false},
      initialTrigger2: {default: ''}
    },

    data() {
      return {
        trigger: false,
        trigger2: '',
        trigger3: '',
      }
    },
    methods: {
      toggle() {
        this.isHidden = !this.isHidden;
      }
    },

    created() {
      this.trigger = this.initialTrigger;
      this.trigger2 = this.initialTrigger2;
    }
  }
</script>
